export const buildRepeatedQueryString = (
  key: string,
  value: string | string[] | undefined,
  separator?: string,
) => {
  if (!value) return '';

  const arr = Array.isArray(value) ? value : [value];

  if (separator !== undefined) {
    return `${key}=${arr.map(item => String(item)).join(separator)}`;
  }

  const searchParams = new URLSearchParams();

  arr.forEach(item => searchParams.append(key, String(item)));

  return searchParams.toString();
};
